<template>
  <v-layout column>
    <h1 class="headline mb-2">
      Информация о товаре!!
    </h1>
    <v-form v-model="valid">
      <v-layout column>
        <v-layout row>
          <v-flex xs3>
            <CatalogReference
              v-model="item.manufacturer"
              label="Производитель*"
              :rules="[v => !!v || '']"
              resource="manufacturers"
              component-name="Manufacturer"
              :outline="true"
              :height-field="44"
              class="ma-2"
              @input="changeParent('manufacturer')"
            />
          </v-flex>
          <v-flex xs3>
            <CatalogReference
              v-model="item.trademark"
              label="TM*"
              :rules="[v => !!v || '']"
              resource="trademarks"
              component-name="Trademark"
              parent-filter="manufacturerId"
              :parent-id="item.manufacturer ? item.manufacturer.id : 0"
              :without-parent-lock="true"
              :outline="true"
              :height-field="44"
              class="ma-2"
              @input="changeTrademark"
            />
          </v-flex>
          <v-flex xs3>
            <CatalogReference
              v-model="item.model"
              :label="modelLabel"
              class="ma-2"
              :rules="floatingRule"
              resource="trademark-models"
              component-name="TrademarkModel"
              :parent-id="item.trademark ? item.trademark.id : 0"
              parent-filter="trademarkId"
              :without-parent-lock="true"
              :filter-name="item.nomenclature ? 'nomenclatureId' : null"
              :filter-value="item.nomenclature ? item.nomenclature.id : null"
              :outline="true"
              :height-field="44"
              :outer-reg-exp="/[`'|\\~]/gi"
              @input="changeModel"
            />
          </v-flex>
          <v-flex xs3>
            <CatalogReference
              v-model="item.article"
              :label="articleLabel"
              class="ma-2"
              :rules="floatingRule"
              resource="articles"
              component-name="Article"
              :parent-id="item.trademark ? item.trademark.id : 0"
              parent-filter="trademarkId"
              :without-parent-lock="true"
              :filter-name="item.nomenclature ? 'nomenclatureId' : null"
              :filter-value="item.nomenclature ? item.nomenclature.id : null"
              :outline="true"
              :height-field="44"
              :outer-reg-exp="/[`'|\\~]/gi"
              @input="changeArticle"
            />
          </v-flex>
        </v-layout>

        <v-layout>
          <v-flex xs6>
            <v-layout align-center>
              <CatalogReference
                v-model="item.nomenclature"
                label="Номенклатура*"
                class="ma-2"
                :rules="[v => !!v || '']"
                resource="nomenclatures"
                component-name="Nomenclature"
                :parent-id="item.model ? item.model.id : 0"
                parent-filter="modelId"
                :without-parent-lock="true"
                :outline="true"
                :height-field="44"
                :outer-reg-exp="/[`'|\\~]/gi"
                @input="isChanged = true"
              />
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    :loading="loadingNomenclature"
                    :disabled="isDisableNomenclature"
                    block
                    class="mx-2"
                    v-on="tooltipNomenclature ? on : false"
                    @click="updateNomenclature()"
                  >
                    Изменить
                  </v-btn>
                </template>
                <span>{{ tooltipNomenclature }}</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="item.material"
              label="Материал*"
              class="ma-2"
              hide-details
              :rules="[v => !!v || '']"
              outline
              height="44"
              @input="isChanged = true"
            />
          </v-flex>
          <v-flex xs2>
            <v-layout
              align-center
              justify-center
              row
              fill-height
            >
              <v-menu menu-props="offsetY">
                <v-chip
                  slot="activator"
                  text-color="white"
                  label
                  :color="getColor(item.fragile)"
                  @click="changeFragile"
                >
                  {{ getVariantTitle(item.fragile) }}
                </v-chip>
              </v-menu>
            </v-layout>
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs4>
            <app-reference
              v-model="item.country"
              label="Страна происхождения*"
              class="ma-2"
              :rules="[v => !!v || '']"
              resource="countries"
              component-name="Country"
              :outline="true"
              :height-field="44"
              @input="isChanged = true"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="item.goodSite"
              label="Сайт товара"
              class="ma-2"
              hide-details
              outline
              height="44"
              :append-icon="item.goodSite ? 'close' : ''"
              @click:append="removeGoodSite"
              @input="isChanged = true"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="item.factoryMarking"
              label="Маркировка на фабрике"
              class="ma-2"
              hide-details
              outline
              height="44"
              @input="isChanged = true"
            />
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs3>
            <CatalogReference
              v-model="item.unit"
              label="Ед. изм.*"
              class="ma-2"
              :rules="[v => !!v || '']"
              resource="units"
              component-name="Unit"
              :outline="true"
              :height-field="44"
              :outer-reg-exp="/[.`,'|/\\~]/gi"
              @input="isChanged = true"
            />
          </v-flex>
          <v-flex xs3>
            <DecimalEditor
              v-model="item.quantity"
              class="ma-2"
              :label="quantityLabel"
              :rules="[v => !!v || '']"
              :outline="true"
              :height-field="44"
              :scale="3"
              @input="changeQuantity"
            />
          </v-flex>
          <v-flex xs3>
            <DecimalEditor
              v-model="item.places"
              class="ma-2"
              label="Всего мест"
              :outline="true"
              :height-field="44"
              @input="isChanged = true"
            />
          </v-flex>
          <v-flex xs3>
            <v-text-field
              v-model="item.size"
              label="Габаритный размер товара"
              class="ma-2"
              hide-details
              outline
              height="44"
              @input="isChanged = true"
            />
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs2>
            <DecimalEditor
              v-model="item.weightNetto"
              class="ma-2"
              label="Вес нетто, кг"
              :scale="3"
              :outline="true"
              :height-field="44"
              @input="changeWeight('netto')"
            />
          </v-flex>
          <v-flex xs3>
            <NettoDiffTable
              :resource="resource"
              :unit="item.unit ? item.unit.title : ''"
              :quantity="item.quantity"
              :weight="item.weightNetto"
              :dictionary-weight="dictionaryWeightNetto"
              :disabled="isDisabledDiffTable"
              :is-changed-weight="isChangedNetto"
              @update="changeWeightNetto"
            />
          </v-flex>
          <v-flex xs2>
            <DecimalEditor
              v-model="item.weightBrutto"
              class="ma-2"
              label="Вес брутто, кг"
              :scale="3"
              :outline="true"
              :height-field="44"
              @input="changeWeight('brutto')"
            />
          </v-flex>
          <v-flex xs3>
            <BruttoDiffTable
              :resource="resource"
              :unit="item.unit ? item.unit.title : ''"
              :quantity="item.quantity"
              :weight="item.weightBrutto"
              :dictionary-weight="dictionaryWeightBrutto"
              :disabled="isDisabledDiffTable"
              :is-changed-weight="isChangedBrutto"
              @update="changeWeightBrutto"
            />
          </v-flex>
          <v-flex xs2>
            <DecimalEditor
              v-model="item.volume"
              class="ma-2"
              label="Объем, м3"
              :scale="3"
              :outline="true"
              :height-field="44"
              @input="isChanged = true"
            />
          </v-flex>
        </v-layout>

        <v-layout row>
          <v-flex xs3>
            <v-layout
              column
              class="ma-2"
            >
              <app-reference
                v-model="item.productCategory"
                label="Категория товара"
                resource="product-categories"
                component-name="ProductCategory"
                :outline="true"
                :height-field="44"
                @input="isChanged = true"
              />
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    :loading="loadingProductCategory"
                    :disabled="isDisableProductCategory"
                    block
                    class="mt-1 my-0"
                    v-on="tooltipProductCategory ? on : false"
                    @click="updateProductCategory()"
                  >
                    Изменить
                  </v-btn>
                </template>
                <span>{{ tooltipProductCategory }}</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <DecimalEditor
              v-model="item.cost"
              class="ma-2"
              label="Стоимость"
              :outline="true"
              :height-field="44"
              :scale="2"
              @input="isChanged = true"
            />
          </v-flex>
          <v-flex xs3>
            <v-layout
              column
              class="ma-2"
            >
              <v-text-field
                v-model="item.customsNumber"
                label="Таможенный код"
                hide-details
                outline
                height="44"
                @input="isChanged = true"
              />
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <v-btn
                    small
                    :loading="loadingCustomsNumber"
                    :disabled="isDisableCustomsNumber"
                    block
                    class="mt-1 my-0"
                    v-on="on"
                    @click="updateСustomsNumber()"
                  >
                    Изменить
                  </v-btn>
                </template>
                <span>{{ tooltipCustomsNumber }}</span>
              </v-tooltip>
            </v-layout>
          </v-flex>
          <v-flex xs3>
            <v-text-field
              v-model="item.notes"
              label="Комментарий"
              class="ma-2"
              hide-details
              outline
              height="44"
              @input="isChanged = true"
            />
          </v-flex>
        </v-layout>
      </v-layout>

      <v-layout
        align-center
        mt-3
      >
        <v-btn
          small
          color="primary"
          :disabled="!isChanged || !valid"
          @click="submit"
        >
          Сохранить
        </v-btn>
        <v-btn
          small
          @click="$emit('cancel')"
        >
          Отмена
        </v-btn>
      </v-layout>
    </v-form>
  </v-layout>
</template>

<script>
import NettoDiffTable from "./NettoDiffTable.vue";
import BruttoDiffTable from "./BruttoDiffTable.vue";
import CatalogReference from "./GoodsDetailsCatalogReference.vue";
import * as goodsDetailsApi from "../../../backend/goodsDetailsApi.js";
import * as articlesApi from "../../../backend/articlesApi.js";

export default {
  components: {
    NettoDiffTable,
    BruttoDiffTable,
    CatalogReference,
  },
  props: ["value", "isEditorItemOpen"],
  data() {
    return {
      valid: false,
      item: null,
      isChanged: false,
      dictionaryWeightNetto: 0,
      dictionaryWeightBrutto: 0,
      isChangedBrutto: false,
      isChangedNetto: false,
      customsNumber: "",
      productCategory: null,
      loadingCustomsNumber: false,
      loadingProductCategory: false,
      nomenclature: null,
      loadingNomenclature: false,
    };
  },
  computed: {
    floatingRule() {
      if (!this.item.model && !this.item.article) {
        return [v => !!v || ""];
      }
      return [];
    },
    modelLabel() {
      if (this.item.article && this.item.article.id) {
        return "Модель";
      }
      return "Модель*";
    },
    articleLabel() {
      if (this.item.model && this.item.model.id) {
        return "Артикул";
      }
      return "Артикул*";
    },
    quantityLabel() {
      return this.item.unit && this.item.unit.title != ""
        ? `Количество, ${this.item.unit.title}*`
        : "Количество + ед.измерения*";
    },
    resource() {
      if (this.item.article && this.item.article.id != 0) {
        return `articles/${this.item.article.id}`;
      } else if (this.item.model && this.item.model.id != 0) {
        return `trademark-models/${this.item.model.id}`;
      } else {
        return "";
      }
    },
    isDisabledDiffTable() {
      if (
        this.item.model?.id > 0 &&
        (this.item.article?.id >= 0 || !this.item.article)
      ) {
        return false;
      }
      if (!this.item.model && this.item.article?.id > 0) {
        return false;
      }
      return true;
    },
    isDisableCustomsNumber() {
      if (this.customsNumber === this.item.customsNumber) {
        return true;
      }
      return !(
        this.item.customsNumber &&
        (this.item.article?.id || this.item.model?.id)
      );
    },
    tooltipCustomsNumber() {
      if (this.customsNumber === this.item.customsNumber) {
        return "";
      }
      if (this.item.article?.id && this.item.model?.id) {
        return "Изменить Таможенный код в Моделе и Артикуле";
      } else if (this.item.article?.id && !this.item.model?.id) {
        return "Изменить Таможенный код в Артикуле";
      } else if (!this.item.article?.id && this.item.model?.id) {
        return "Изменить Таможенный код в Моделе";
      } else {
        return "";
      }
    },
    isDisableProductCategory() {
      if (
        !this.item.article?.id &&
        !this.item.model?.id &&
        !this.productCategory &&
        !this.item.productCategory?.id
      ) {
        return true;
      } else if (this.productCategory?.id === this.item.productCategory?.id) {
        return true;
      } else {
        return false;
      }
    },
    tooltipProductCategory() {
      if (this.productCategory?.id === this.item.productCategory?.id) {
        return "";
      }
      if (this.item.article?.id && this.item.model?.id) {
        return "Изменить Категорию товара в Моделе и Артикуле";
      } else if (this.item.article?.id && !this.item.model?.id) {
        return "Изменить Категорию товара в Артикуле";
      } else if (!this.item.article?.id && this.item.model?.id) {
        return "Изменить Категорию товара в Моделе";
      } else {
        return "";
      }
    },
    isDisableNomenclature() {
      if (
        !this.item.article?.id &&
        !this.item.model?.id &&
        !this.nomenclature &&
        !this.item.nomenclature?.id
      ) {
        return true;
      } else if (this.nomenclature?.id === this.item.nomenclature?.id) {
        return true;
      } else {
        return false;
      }
    },
    tooltipNomenclature() {
      if (this.nomenclature?.id === this.item.productCategory?.id) {
        return "";
      }
      if (this.item.article?.id && this.item.model?.id) {
        return "Изменить Номенклатуру в Моделе и Артикуле";
      } else if (this.item.article?.id && !this.item.model?.id) {
        return "Изменить Номенклатуру в Артикуле";
      } else if (!this.item.article?.id && this.item.model?.id) {
        return "Изменить Номенклатуру в Моделе";
      } else {
        return "";
      }
    },
  },
  created() {
    if (this.value) {
      this.item = {
        id: this.value.id,
        manufacturer: this.value.manufacturer,
        article: this.value.article,
        country: this.value.country,
        goodSite: this.value.goodSite,
        factoryMarking: this.value.factoryMarking,
        material: this.value.material,
        model: this.value.model,
        nomenclature: this.value.nomenclature,
        places: this.value.places,
        quantity: this.value.quantity,
        size: this.value.size,
        trademark: this.value.trademark,
        unit: this.value.unit,
        weightBrutto: this.value.weightBrutto,
        weightNetto: this.value.weightNetto,
        volume: this.value.volume,
        fragile: this.value.fragile,
        productCategory: this.value.productCategory,
        notes: this.value.notes,
        cost: this.value.cost,
        customsNumber: this.value.customsNumber,
      };
      this.customsNumber = this.value.customsNumber;
      this.changeGoodsDependencies();
    }
  },
  methods: {
    async submit() {
      if (await this.addEntitites()) {
        const changedItem = {
          id: this.item.id,
          manufacturerId:
            this.item.manufacturer && this.item.manufacturer.id !== 0
              ? this.item.manufacturer.id
              : null,
          articleId:
            this.item.article && this.item.article.id !== 0
              ? this.item.article.id
              : null,
          countryId:
            this.item.country && this.item.country.id !== 0
              ? this.item.country.id
              : null,
          goodSite: this.item.goodSite,
          factoryMarking: this.item.factoryMarking,
          material: this.item.material || "",
          modelId:
            this.item.model && this.item.model.id != 0
              ? this.item.model.id
              : null,
          nomenclatureId:
            this.item.nomenclature && this.item.nomenclature.id !== 0
              ? this.item.nomenclature.id
              : null,
          places: this.item.places ? this.item.places : 0,
          quantity: this.item.quantity ? this.item.quantity : 0,
          size: this.item.size || "",
          trademarkId:
            this.item.trademark && this.item.trademark.id !== 0
              ? this.item.trademark.id
              : null,
          unitId:
            this.item.unit && this.item.unit.id !== 0
              ? this.item.unit.id
              : null,
          weightBrutto: this.item.weightBrutto ? this.item.weightBrutto : 0,
          weightNetto: this.item.weightNetto ? this.item.weightNetto : 0,
          volume: this.item.volume ? this.item.volume : 0,
          fragile: this.item.fragile,
          productCategoryId: this.item.productCategory
            ? this.item.productCategory.id
            : null,
          notes: this.item.notes,
          cost: this.item.cost ? this.item.cost : 0,
          customsNumber: this.item.customsNumber || "",
        };
        const res = await goodsDetailsApi.editGoodsDetailItem(changedItem);
        if (
          res.data.IsChanged &&
          (res.data.WeightNettoToChange || res.data.WeightBruttoToChange)
        ) {
          this.$emit("change", this.item);
        } else if (res.data.IsChanged) {
          this.$emit("changeCatalogValue", {
            item: this.item,
            changeInfo: res.data,
          });
        } else {
          this.$emit("change", this.item);
        }
        this.changeWeightNetto();
        this.changeWeightBrutto();
      }
    },
    async addEntitites() {
      if (this.item.nomenclature && this.item.nomenclature.id == -1) {
        const res = await goodsDetailsApi.createNomenclature(
          this.item.nomenclature.title,
        );
        this.item.nomenclature.id = res.data;
      }
      if (this.item.unit && this.item.unit.id == -1) {
        const res = await goodsDetailsApi.createUnit(this.item.unit.title);
        this.item.unit.id = res.data;
      }

      let result = true;
      if (this.item.article && this.item.article.id == -1) {
        result = await this.addArticle();
      } else if (this.item.model && this.item.model.id == -1) {
        result = await this.addModel();
      } else if (this.item.trademark && this.item.trademark.id == -1) {
        result = await this.addTrademark();
      } else if (this.item.manufacturer && this.item.manufacturer.id == -1) {
        result = await this.addManufacturer();
      }

      return result;
    },
    async addManufacturer() {
      if (this.item.manufacturer && this.item.manufacturer.id == -1) {
        const res = await goodsDetailsApi.createManufacturer(
          this.item.manufacturer.title,
        );
        this.item.manufacturer.id = res.data;
        return res.data;
      }
    },
    async addTrademark() {
      if (this.item.manufacturer && this.item.manufacturer.id == -1) {
        this.item.manufacturer.id = await this.addManufacturer();
      }
      const res = await goodsDetailsApi.createTrademark(
        this.item.trademark.title,
        this.item.manufacturer.id,
      );
      this.item.trademark.id = res.data;
      return res.data;
    },
    async addModel() {
      if (this.item.trademark && this.item.trademark.id == -1) {
        this.item.trademark.id = await this.addTrademark();
      }
      if (this.item.manufacturer && this.item.manufacturer.id == -1) {
        this.item.manufacturer.id = await this.addManufacturer();
      }
      const model = {
        title: this.item.model.title,
        manufacturerId: this.item.manufacturer.id,
        trademarkId: this.item.trademark.id,
        nomenclatureId: this.item.nomenclature.id,
        unitId: this.item.unit.id,
        countryId: this.item.country.id,
        productSite: this.item.goodSite,
        weightBrutto: this.item.weightBrutto
          ? +(this.item.weightBrutto / this.item.quantity).toFixed(3)
          : 0,
        weightNetto: this.item.weightNetto
          ? +(this.item.weightNetto / this.item.quantity).toFixed(3)
          : 0,
        material: this.item.material,
        dimensions: this.item.size,
      };

      const res = await goodsDetailsApi.createModel(model);

      this.item.model.id = res.data;
      return res.data;
    },
    async addArticle() {
      if (this.item.model && this.item.model.id == -1) {
        this.item.model.id = await this.addModel();
      }
      if (this.item.trademark && this.item.trademark.id == -1) {
        this.item.trademark.id = await this.addTrademark();
      }
      if (this.item.manufacturer && this.item.manufacturer.id == -1) {
        this.item.manufacturer.id = await this.addManufacturer();
      }
      const article = {
        title: this.item.article.title,
        manufacturerId: this.item.manufacturer.id,
        trademarkId: this.item.trademark.id,
        modelId: this.item.model?.id,
        nomenclatureId: this.item.nomenclature.id,
        unitId: this.item.unit.id,
        countryId: this.item.country.id,
        productSite: this.item.goodSite,
        weightBrutto: this.item.weightBrutto
          ? +(this.item.weightBrutto / this.item.quantity).toFixed(3)
          : 0,
        weightNetto: this.item.weightNetto
          ? +(this.item.weightNetto / this.item.quantity).toFixed(3)
          : 0,
        material: this.item.material,
        dimensions: this.item.size,
        customsNumber: this.item.customsNumber,
      };
      const res = await goodsDetailsApi.createArticle(article);

      this.item.article.id = res.data;
      return res.data;
    },
    async changeTrademark(payload) {
      this.isChanged = true;
      if (payload && payload.id === -1) return;
      this.changeParent("trademark");

      if (this.item.trademark) {
        this.item.manufacturer = await goodsDetailsApi.changeTrademark(
          this.item.trademark.id,
        );
      }
    },
    async changeNomenclature(payload) {
      this.isChanged = true;
      if (payload && payload.id === -1) return;
      this.changeParent("nomenclature");

      if (this.item.trademark) {
        this.item.manufacturer = await goodsDetailsApi.changeNomenclature(
          this.item.trademark.id,
        );
      }
    },
    async changeModel(payload) {
      this.isChanged = true;
      this.clearDictionaryWeights();
      if (payload && payload.id === -1) {
        this.changeParent("model");
        return;
      }
      if (this.item.model?.id > 0) {
        this.changeParent("model");

        const res = await articlesApi.getModel(this.item.model.id);
        this.item.manufacturer = {
          id: res.data.Manufacturer.Id,
          title: res.data.Manufacturer.Title,
        };
        this.item.trademark = {
          id: res.data.Trademark.Id,
          title: res.data.Trademark.Title,
        };
        this.item.nomenclature = res.data.Nomenclature
          ? {
            id: res.data.Nomenclature.Id,
            title: res.data.Nomenclature.Title,
          }
          : null;
        this.item.country = {
          id: res.data.Country.Id,
          title: res.data.Country.Title,
        };
        this.item.unit = {
          id: res.data.Unit.Id,
          title: res.data.Unit.Title,
        };
        this.item.goodSite = res.data.ProductSite;
        this.item.material = res.data.Material;
        this.item.size = res.data.Dimensions;
        this.item.customsNumber = res.data.CustomsNumber;
        this.customsNumber = res.data.CustomsNumber;
        this.item.productCategory = res.data.ProductCategory
          ? {
            id: res.data.ProductCategory.Id,
            title: res.data.ProductCategory.Title,
          }
          : null;
        this.calculatedWeight(this.item.quantity);
        this.changeGoodsDependencies();
      }
    },
    async changeArticle(payload) {
      this.isChanged = true;
      this.clearDictionaryWeights();
      if (payload && payload.id === -1) {
        this.changeParent("article");
        return;
      }
      this.changeParent("article");

      if (this.item.article?.id > 0) {
        const res = await articlesApi.getArticle(this.item.article.id);
        this.item.model = res.data.Model
          ? {
            id: res.data.Model.Id,
            title: res.data.Model.Title,
          }
          : null;
        this.item.manufacturer = {
          id: res.data.Manufacturer.Id,
          title: res.data.Manufacturer.Title,
        };
        this.item.trademark = {
          id: res.data.Trademark.Id,
          title: res.data.Trademark.Title,
        };
        this.item.nomenclature = {
          id: res.data.Nomenclature.Id,
          title: res.data.Nomenclature.Title,
        };
        this.item.country = {
          id: res.data.Country.Id,
          title: res.data.Country.Title,
        };
        this.item.unit = {
          id: res.data.Unit.Id,
          title: res.data.Unit.Title,
        };
        this.item.productCategory = res.data.ProductCategory
          ? {
            id: res.data.ProductCategory.Id,
            title: res.data.ProductCategory.Title,
          }
          : null;
        this.item.goodSite = res.data.ProductSite;
        this.item.material = res.data.Material;
        this.item.size = res.data.Dimensions;
        this.dictionaryWeightNetto = res.data.WeightNetto;
        this.dictionaryWeightBrutto = res.data.WeightBrutto;
        this.item.customsNumber = res.data.CustomsNumber;
        this.customsNumber = res.data.CustomsNumber;
        this.calculatedWeight(this.item.quantity);
        this.changeGoodsDependencies();
      }
    },
    changeParent(changedItemName) {
      switch (changedItemName) {
        case "manufacturer":
          this.isChanged = true;
          this.item.trademark = null;
          this.changeParent("trademark");
          break;
        case "trademark":
          this.item.model = null;
          this.item.article = null;
          this.item.nomenclature = null;
          this.item.country = null;
          this.item.goodSite = null;
          this.item.material = null;
          this.item.size = null;
          this.item.weightBrutto = null;
          this.item.weightNetto = null;
          this.item.customsNumber = null;
          this.customsNumber = null;
          this.dictionaryWeightNetto = null;
          this.dictionaryWeightBrutto = null;
          break;
        case "model":
          this.item.article = null;
          this.changeParent("article");
          break;
        case "article":
          this.item.nomenclature = null;
          this.item.productCategory = null;
          this.item.goodSite = null;
          this.item.material = null;
          this.item.size = null;
          this.item.weightBrutto = null;
          this.item.weightNetto = null;
          this.customsNumber = null;
          this.dictionaryWeightNetto = null;
          this.dictionaryWeightBrutto = null;
          break;
        case "nomenclature":
          this.item.model = null;
          this.item.article = null;
          this.changeParent("article");
          break;
      }
    },
    changeFragile() {
      this.item.fragile = !this.item.fragile;
      this.isChanged = true;
    },
    getColor(labelValue) {
      if (labelValue) {
        return "error";
      } else {
        return "gray";
      }
    },
    getVariantTitle(labelValue) {
      if (labelValue) {
        return "Хрупкий";
      } else {
        return "Не хрупкий";
      }
    },
    changeWeightNetto(value) {
      this.dictionaryWeightNetto = value;
      this.isChangedNetto = false;
    },
    changeWeightBrutto(value) {
      this.dictionaryWeightBrutto = value;
      this.isChangedBrutto = false;
    },
    async changeGoodsDependencies() {
      if (this.item.article && this.item.article.id > 0) {
        const res = await articlesApi.getArticle(this.item.article.id);
        this.dictionaryWeightNetto = res.data.WeightNetto;
        this.dictionaryWeightBrutto = res.data.WeightBrutto;
        this.customsNumber = res.data.CustomsNumber;
        this.productCategory = res.data.ProductCategory
          ? {
            id: res.data.ProductCategory.Id,
            title: res.data.ProductCategory.Title,
          }
          : null;
        this.nomenclature = res.data.Nomenclature
          ? {
            id: res.data.Nomenclature.Id,
            title: res.data.Nomenclature.Title,
          }
          : null;
      } else if (this.item.model && this.item.model.id > 0) {
        const res = await articlesApi.getModel(this.item.model.id);
        this.dictionaryWeightNetto = res.data.WeightNetto;
        this.dictionaryWeightBrutto = res.data.WeightBrutto;
        this.customsNumber = res.data.CustomsNumber;
        this.productCategory = res.data.ProductCategory
          ? {
            id: res.data.ProductCategory.Id,
            title: res.data.ProductCategory.Title,
          }
          : null;
        this.nomenclature = res.data.Nomenclature
          ? {
            id: res.data.Nomenclature.Id,
            title: res.data.Nomenclature.Title,
          }
          : null;
      } else {
        this.dictionaryWeightNetto = 0;
        this.dictionaryWeightBrutto = 0;
        this.productCategory = null;
      }
    },
    clearDictionaryWeights() {
      if (this.item.article || this.item.model) {
        this.changeGoodsDependencies();
      }
      this.dictionaryWeightNetto = 0;
      this.dictionaryWeightBrutto = 0;
      this.productCategory = null;
    },
    removeGoodSite() {
      this.item.goodSite = "";
      this.isChanged = true;
    },
    changeQuantity(value) {
      this.isChanged = true;
      if (!value) {
        return;
      }
      this.calculatedWeight(value);
    },
    calculatedWeight(value) {
      if (!value) {
        return;
      }
      this.item.weightNetto = +(value * this.dictionaryWeightNetto).toFixed(3);
      this.item.weightBrutto = +(value * this.dictionaryWeightBrutto).toFixed(
        3,
      );
    },
    changeWeight(value) {
      if (value === "brutto") {
        this.isChangedBrutto = true;
      }
      if (value === "netto") {
        this.isChangedNetto = true;
      }
      this.isChanged = true;
    },
    async updateСustomsNumber() {
      this.loadingCustomsNumber = true;
      if (this.item.model?.id) {
        await articlesApi.updateModelTrademarkModel(
          this.item.model.id,
          this.item.customsNumber,
        );
      }
      if (this.item.article?.id) {
        await articlesApi.updateArticleСustomsNumber(
          this.item.article.id,
          this.item.customsNumber,
        );
      }
      this.customsNumber = this.item.customsNumber;
      this.showInfo("Таможенный код изменен");
      this.loadingCustomsNumber = false;
    },
    async updateProductCategory() {
      this.loadingProductCategory = true;
      if (this.item.model?.id) {
        await articlesApi.updateTrademarkProductCategory(
          this.item.model.id,
          this.item.productCategory.id,
        );
      }
      if (this.item.article?.id) {
        await articlesApi.updateArticelProductCategory(
          this.item.article.id,
          this.item.productCategory.id,
        );
      }
      this.productCategory = this.item.productCategory;
      this.showInfo("Категория товара изменена");
      this.loadingProductCategory = false;
    },
    async updateNomenclature() {
      this.loadingNomenclature = true;
      if (this.item.model?.id) {
        await articlesApi.updateTrademarkNomenclature(
          this.item.model.id,
          this.item.nomenclature.id,
        );
      }
      if (this.item.article?.id) {
        await articlesApi.updateArticelNomenclature(
          this.item.article.id,
          this.item.nomenclature.id,
        );
      }
      this.nomenclature = this.item.nomenclature;
      this.showInfo("Номенклатура изменена");
      this.loadingNomenclature = false;
    },
  },
};
</script>
